import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const CONSECUTIVE_SLASHES = /\/{2,}/g;

export const NormalizedRoute = ({ children }: PropsWithChildren) => {
  const { pathname, search, hash } = useLocation();
  const normalizedPathname = pathname.replace(CONSECUTIVE_SLASHES, '/');

  if (normalizedPathname !== pathname) {
    return <Navigate to={`${normalizedPathname}${search}${hash}`} replace  data-track-source-anchor="1d23a0b85b;normalized-route-navigate"/>;
  }

  return <>{children}</>;
};
